import { TableCell } from '@toggle/design-system';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { HistoryMeta } from '@/api/asset/asset-schema';

import { PastEpisodeCell } from '../past-episode-cell/PastEpisodeCell';
import * as S from './PastEpisodesRow.styles';

interface PastEpisodesRowProps {
  meta: HistoryMeta;
}

export const PastEpisodesRow = ({ meta }: PastEpisodesRowProps) => {
  const { t } = useTranslation('common');

  const oneWeek = meta.medians.w1;
  const twoWeek = meta.medians.w2;
  const oneMonth = meta.medians.m1;

  return (
    <S.PastEpisodesRow data-testid="past-episodes-row">
      <TableCell alignment="start" condensed isUpperCase={false}>
        {t('table.numberOfOccurrences', { count: meta.count })}
      </TableCell>
      <TableCell empty condensed />
      <PastEpisodeCell value={oneWeek} />
      <PastEpisodeCell value={twoWeek} />
      <PastEpisodeCell value={oneMonth} />
    </S.PastEpisodesRow>
  );
};
